import React from 'react';
import { EXPERIENCE } from '../constants/data';

const Experience = () => {
  return (
    <section id="experience" className="section experience reveal">
      <div className="container">
        <div className="section-head">
          <span className="section-head__index">02</span>
          <h2 className="section-head__title">Experience</h2>
        </div>

        <div className="timeline">
          {EXPERIENCE.map((job) => (
            <article key={job.id} className="timeline__item">
              <div className="timeline__marker">
                <span className="timeline__dot" />
              </div>
              <div className="timeline__content">
                <span className="timeline__period">{job.period}</span>
                <h3 className="timeline__role">{job.role}</h3>
                <p className="timeline__company">{job.company}</p>
                <ul className="timeline__points">
                  {job.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
